<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.specialties', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form  @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="professions-group"
                                        :label="$t('message.select')+' '+$tc('message.professions', 1)"
                                        label-for="professions">
                                    <!-- Options -->
                                    <select id="professions"
                                            v-model="$v.form.profession.$model"
                                            class="form-control is-invalid retirerBordure"
                                            :state="$v.form.profession.$dirty ? !(errorshasField('profession_id') || $v.form.profession.$error) : null"
                                            required>
                                        <option v-for="item in mProfessions" :value="item.value" :key="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="$v.form.profession.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('profession_id')">
                                        {{ getErrorsField('profession_id') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="nom-group"
                                        :label="$t('message.name')"
                                        label-for="nom"
                                        description=""
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.nom.$model"
                                            :state="$v.form.nom.$dirty ? !(errorshasField('name') || $v.form.nom.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('name')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.nom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.nom.minLength">
                                        {{ $t('message.minCharacters', { n: 3 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="errorshasField('name')">
                                        {{ getErrorsField('name') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button @click="onSubmit"  variant="primary">
                                {{ $t('message.save') }}
                            </b-button>

                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required,minLength } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from "slim-select";

    export default {
        name: "AddSpecialty",

        computed: {
            ...mapGetters(["professions", "errors",'hasAdminRole',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            mProfessions: function() {
                let pArray = [];

                _.forOwn(this.professions, function(value, key) {
                    pArray.push({ text: value.name, value: value.id });
                });

                return pArray;
            }
        },

        data() {
            return {
                form: {
                    nom: '',
                    profession: null,
                },
                show: true
            }
        },

        methods: {
            getProfessions: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getProfessions', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        profession_id: this.form.profession,
                        name: this.form.nom
                    };

                    let successMessage = this.$i18n.t('message.specialtyCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createSpecialty', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.nom = '';
                this.form.profession = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                nom: {
                    required,
                    minLength: minLength(3)

                },
                profession: {
                    required
                }
            }
        },

        mounted() {
            // Retrieve list of professions
            this.getProfessions();
            new SlimSelect({
                select: '#professions'
            });
        }
    }
</script>

<style scoped>

</style>